export default {"src":"/_next/static/media/close-bold.fd38de8f.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};